import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Contratos } from './Contratos';
import { Departamentos } from './Departamentos';
import { Documentos } from './Documentos';
import { FichaFuncionario } from './FichaFuncionario';
import { Funcionarios } from './Funcionarios';
import { Funcoes } from './Funcoes';
import { Habilidades } from './Habilidades';
import { Jornada } from './Jornada';
import { i18n } from './i18n';
import { MeusDados } from './MeusDados';
import { buscaPessoas } from './busca-global';

const modulo: ModuloWeb = {
  slug: 'pessoas',
  menu: 'pessoas',
  ordem: 10,
  abas: [
    { chave: 'funcionarios', permissao: 'pessoas.ver', componente: Funcionarios },
    { chave: 'departamentos', permissao: 'pessoas.ver', componente: Departamentos },
    { chave: 'funcoes', permissao: 'pessoas.ver', componente: Funcoes },
    { chave: 'contratos', permissao: 'pessoas.ver', componente: Contratos },
    // Documentos pessoais são confidenciais (review r3): só com salário e documentos.
    { chave: 'documentos', permissao: 'pessoas.confidencial', componente: Documentos },
    { chave: 'jornada', permissao: 'pessoas.ver', componente: Jornada },
    { chave: 'habilidades', permissao: 'pessoas.ver', componente: Habilidades },
  ],
  rotasExtras: [{ caminho: 'funcionario/:id', componente: FichaFuncionario }],
  // "Meus dados" (21/10): a própria ficha em Minha conta, só leitura.
  abaMinhaConta: MeusDados,
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaPessoas,
};

export default modulo;
